"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { ClipboardCheck, Crown, Lightbulb } from "lucide-react";
export default function OurExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const expertiseAreas = [{
    id: 1,
    icon: ClipboardCheck,
    title: "Technical Project Management",
    description: "From hardware infrastructure and server installations to complex software rollouts, we manage the heavy lifting. We act as your technical general contractor, coordinating vendors and overseeing projects to ensure they are completed securely, on time, and within budget.",
    delay: "animate-fade-in-up"
  }, {
    id: 2,
    icon: Crown,
    title: "Fractional CTO Leadership",
    description: "Get executive-level technical leadership without the full-time overhead. We provide the strategic roadmap your business needs, with a heavy focus on risk mitigation and long-term stability to ensure your technology supports your growth instead of hindering it.",
    delay: "animate-fade-in-up-delay-100"
  }, {
    id: 3,
    icon: Lightbulb,
    title: "AI Automation Solutions",
    description: "While CAIT is our flagship, we believe the best AI solutions are built to solve specific, real-world problems. We are looking for partners ready to innovate—tell us the bottlenecks in your workflow, and we will design the automation to clear them.",
    delay: "animate-fade-in-up-delay-200"
  }];
  return <section id="our-expertise" ref={ref} className="bg-light-background py-16 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground-light md:text-5xl">
            Our Expertise
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {expertiseAreas.map((area, i) => {
          const Icon = area.icon;
          return <Card key={area.id} data-index={i} className={`card bg-white shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? area.delay : "opacity-0"}`}>
                <CardHeader className="items-center text-center">
                  <div className="mb-4 flex size-16 items-center justify-center rounded-full bg-primary-light">
                    <Icon className="size-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground-light">
                    {area.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-center">
                  <p className="text-muted text-sm leading-relaxed">
                    {area.description}
                  </p>
                  <Link to="#">
                    <Button variant="outline" size="sm" className="w-full">
                      Learn More
                    </Button>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}